import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider, UiKitToastsContextProvider } from '@cian/ui-kit/context';
import { FC, ReactElement } from 'react';
import { Provider } from 'react-redux';

import { NotificationsContainer } from '../Notifications';
import { PageContainer } from '../Page';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
  /**
   * Заглушка корневого error boundary. В браузере это снимок SSR-разметки, чтобы ошибка
   * в гидрации или после неё не стирала контент для индексации; на сервере не передаётся.
   */
  errorStub?: ReactElement;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context, errorStub }) => {
  const {
    logger,
    custom: { initialDeviceType },
    microfrontendsRegistry,
  } = context;

  return (
    <ErrorLogComponent logger={logger} errorStub={errorStub}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <MicrofrontendProvider registry={microfrontendsRegistry}>
                <PageContainer />
                <NotificationsContainer />
              </MicrofrontendProvider>
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
